import { uniqueId } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Spinner } from 'reactstrap';
import Container from 'reactstrap/lib/Container';
import usePdfCost from '../../hooks/usePdf/usePdfCost';
import { t } from '../common/Translate';
import { currencySign } from '../../Utils/currencySign';

const PdfCost = () => {
  const { recordKey, referential, language } = useParams();
  const { isLoading, infos, country, report, symbol, zoneList } = usePdfCost(recordKey, referential, language);
  const { vehicleInfos, costExlTax, costInclTax, TVA, VAT } = infos;

  // useEffect(() => {
  //   window.zE('messenger:set', 'cookies', false);
  // });

  let content;
  if (report) {
    content = zoneList.map((zone) => {
      if (!report[zone] || report[zone]?.totals?.[referential] === undefined) return null;
      return (
        <div key={uniqueId(zone)}>
          <Row className="pdf-row mt-2">
            <Col className="font-weight-semibold text-uppercase">{t(zone)}</Col>
            <Col className="text-right mr-4">{report[zone]?.totals[referential] === 0 && '-'}</Col>
          </Row>
          {report[zone]?.damages.map((d, i) => {
            if (d.cost > 0 && d.referential === referential) {
              return (
                <Row className="pdf-row hide-border" key={uniqueId(i)}>
                  <Col>
                    <Row>
                      <Col>
                        <span className="text-uppercase">{t(d.element)}</span>{' '}
                        <span className="pdf-value">{` - ${(d.is_custom && t(d.custom_damage)) || t(d.damage)}`}</span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>{d.is_custom && <span className="font-italic">{t('is_custom')}</span>}</Col>
                    </Row>
                  </Col>
                  <Col className="text-right">{`${currencySign(d.cost, country)} [${t(symbol)}]`}</Col>
                </Row>
              );
            }
            return null;
          })}
          {report[zone]?.totals[referential] > 0 && (
            <Row className="pdf-row">
              <Col xs={5} md={9} lg={9} className="text-right">
                {t('total')}
              </Col>
              <Col className="text-right pdf-text-total pdf-text-bold">{`${currencySign(
                report[zone]?.totals[referential],
                country,
              )} [${t(symbol)}]`}</Col>
            </Row>
          )}
        </div>
      );
    });
  }

  if (isLoading) return <Spinner id="isLoading" />;
  return (
    <div className="pdf">
      <h1 className="page-title text-center">
        <span>{t('titlePdfDamagesCosts')}</span>
      </h1>
      <Container className="mt-3">
        <div className="pdf-bloc">
          {vehicleInfos &&
            Object.entries(vehicleInfos).map((info) => (
              <Row key={uniqueId(info[0])}>
                <Col className="pdf-bloc-col">{t(info[0])}</Col>
                <Col className="pdf-bloc-col">{info[1]}</Col>
              </Row>
            ))}
        </div>
        <Row className="pdf-row mb-3 mt-3">
          <Col>{`${t('cost_referential')} : ${t(referential)}`}</Col>
          <Col />
        </Row>
        {content && content}
        <Row className="pdf-row hide-border mt-3">
          <Col />
          <Col className="text-right">{t('costExclTax')}</Col>
          <Col className="text-right">{`${t('VAT')} ${VAT} %`}</Col>
          <Col className="text-right">{t('costInclTax')}</Col>
        </Row>
        <Row className="pdf-row">
          <Col />
          <Col className="text-right pdf-text-bold">{(costExlTax && currencySign(costExlTax, country)) || '-'}</Col>
          <Col className="text-right pdf-text-bold">{(TVA && currencySign(TVA.toFixed(2), country)) || '-'}</Col>
          <Col className="text-right pdf-text-bold">{(costInclTax && currencySign(costInclTax, country)) || '-'}</Col>
        </Row>
      </Container>
    </div>
  );
};

export default PdfCost;
